import type { IntlShape } from 'react-intl';

import usEnJson from 'lang/en-US.json';

type MessageDescriptor = keyof typeof usEnJson;

type Values = Record<string, string | number>;

export function t(intl: IntlShape, id: MessageDescriptor, values?: Values): string {
  return intl.formatMessage({ id }, values);
}
